import React, { useContext, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm } from "react-hook-form";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("description", data.description);

      const response = await postData("/information/terms-condition", formData, true);

      setShowModal({
        code: response.code,
        message: response.message,
      });

      if (response.success) {
        reset();
      }

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Terms And Condition</Card.Title>
              <hr />

              <Container>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={10} md={12} className="mx-auto Add-content">
                      {/* Name */}
                      <Row className="mt-4">
                        <Form.Label column sm={2}>
                          Name
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            {...register("name", {
                              required: "Name is required",
                            })}
                          />
                          {errors.name && (
                            <span className="text-danger">
                              {errors.name.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Description */}
                      <Row className="mt-4">
                        <Form.Label column sm={2}>
                          Description
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            as="textarea"
                            rows={14}
                            placeholder="Description"
                            {...register("description", {
                              required: "Description is required",
                            })}
                          />
                          {errors.description && (
                            <span className="text-danger">
                              {errors.description.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Buttons */}
                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name="cancel"
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton name="save" type="submit" />
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default AddOffCanvance;
